import { type Control, Controller, type UseFormRegister, useWatch } from 'react-hook-form'

import { ButtonGroup } from '@/components/ui/button-group'
import { FieldError } from '@/components/ui/field-error'
import { Input } from '@/components/ui/input'
import type { Step3FormValues } from './claimStep3Values'

const CARGO_OPTIONS: { value: boolean; label: string }[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No — running empty' },
]

interface ClaimCargoBrokerSectionProps {
  control: Control<Step3FormValues>
  register: UseFormRegister<Step3FormValues>
}

export function ClaimCargoBrokerSection({ control, register }: ClaimCargoBrokerSectionProps) {
  const cargoOnBoard = useWatch({ control, name: 'cargoOnBoard' })

  return (
    <>
      <Controller
        name="cargoOnBoard"
        control={control}
        rules={{ validate: (v) => v !== null || 'Please choose.' }}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-neutral-700">Was cargo on board? *</label>
            <ButtonGroup options={CARGO_OPTIONS} value={field.value} onChange={field.onChange} />
            <FieldError message={fieldState.error?.message} />
          </div>
        )}
      />

      {cargoOnBoard === true && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-neutral-700">Freight broker name</label>
            <Input placeholder="e.g. CH Robinson, Echo Global, Coyote" {...register('freightBrokerName')} />
            <p className="text-xs text-neutral-500">The company that arranged this load, if applicable</p>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-neutral-700">Freight broker contact</label>
            <Input placeholder="Phone or email" {...register('freightBrokerContact')} />
          </div>
        </div>
      )}
    </>
  )
}
